import viewMixin from '@/components/core/consumers/viewMixin';
import ApiService from '@/services/apiService';
import { userItemsPerListMixin } from '@/utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
import { mapState, mapGetters } from 'vuex';
const emptyModel = {
  transformer: {
    definition: '$.value',
    type: 'jsonata',
    contentTypes: {}
  },
  properties: {}
};
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewConnectorsConsumersTransformers',
  mixins: [viewMixin, userItemsPerListMixin],
  data() {
    return {
      searchItem: '',
      selectedAccounts: [],
      accounts: [],
      selectedAccount: null,
      loadingAccounts: true,
      transformerTypes: ['jsonata', 'javascript'],
      transformerModel: cloneDeep(emptyModel),
      deletePrompt: false,
      deleteItemId: null,
      cascadePrompt: false,
      cascadeFlows: [],
      cascadeItemId: null,
      tableOptions: defaultTableOptions
    };
  },
  computed: {
    ...mapState('authentication', ['tenantId']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    hasNoTransformers() {
      return this.transformers.length === 0;
    },
    inputTypes() {
      switch (this.transformerModel.transformer.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    outputTypes() {
      switch (this.transformerModel.transformer.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    showCodeMirror() {
      // return this.transformerModel.transformer.type === 'jsonata';
      return true;
    },
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('Connectors.Filter.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.type'),
          sortable: true,
          value: 'transformer.type',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.outputType'),
          sortable: true,
          value: 'transformer.contentTypes.output'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.createdAt'),
          value: 'createdAt'
        }, {
          value: 'actions',
          align: 'end'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  },
  watch: {
    selectedAccounts() {
      this.fetchTransformers(this.selectedAccounts);
    },
    inputTypes() {
      if (this.inputTypes.length === 1 || this.inputTypes.indexOf(this.transformerModel.transformer.contentTypes.input) < 0) {
        this.transformerModel.transformer.contentTypes.input = this.inputTypes[0];
      }
    },
    outputTypes() {
      if (this.outputTypes.length === 1 || this.outputTypes.indexOf(this.transformerModel.transformer.contentTypes.output) < 0) {
        this.transformerModel.transformer.contentTypes.output = this.outputTypes[0];
      }
    },
    'transformerModel.transformer.type'() {
      switch (this.transformerModel.transformer.type) {
        case 'jsonata':
          this.transformerModel.transformer.definition = '$.value';
          break;
        case 'javascript':
          this.transformerModel.transformer.definition = 'return x.value';
          break;
      }
    }
  },
  created() {
    this.fetchAccounts();
  },
  methods: {
    openEdit(item = null) {
      if (!item) {
        this.selectedAccount = null;
        this.$router.push('/connectors/consumers/transformers/create');
      } else {
        this.selectedAccount = this.accounts.find(acc => acc.id === item.tenantId);
        this.$router.push(`/connectors/consumers/transformers/${item.id}`);
      }
    },
    save() {
      let promise = null;
      if (this.transformerModel.id) {
        promise = ApiService.consumerTransformersUpdate(this.transformerModel.id, this.transformerModel);
      } else {
        promise = ApiService.consumerTransformersCreate(this.selectedAccount, this.transformerModel);
      }
      promise.then(() => {
        this.fetchTransformers();
        this.closeDialog();
      }).catch(e => {
        this.$snack(e.response.data.message, 'error');
      });
    },
    async showDeletePrompt(id) {
      this.deleteItemId = id;
      try {
        const usage = await ApiService.consumerTransformersGetUsage(id);
        if (usage && Array.isArray(usage.flows) && usage.flows.length) {
          this.cascadeFlows = usage.flows;
          this.cascadeItemId = id;
          this.cascadePrompt = true;
          return;
        }
      } catch (e) {
        // fallback to generic prompt if usage endpoint fails
      }
      this.deletePrompt = true;
    },
    async deleteTransformer(id) {
      try {
        await ApiService.consumerTransformersDelete(id);
        this.fetchTransformers(this.selectedAccounts);
      } catch (error) {
        var _error$response;
        const msg = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.message) || (error === null || error === void 0 ? void 0 : error.message) || '';
        let payload = null;
        try {
          payload = JSON.parse(msg);
        } catch {
          // ignore
        }
        if (payload && payload.componentType === 'transformer' && Array.isArray(payload.flows) && payload.flows.length) {
          this.cascadeFlows = payload.flows;
          this.cascadeItemId = id;
          this.cascadePrompt = true;
        } else {
          var _error$response2;
          this.$snack(((_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.message) || this.$i18n_t('Common.error'), 'error');
        }
      } finally {
        this.deletePrompt = false;
      }
    },
    async confirmCascadeDelete() {
      try {
        await ApiService.consumerTransformersDelete(this.cascadeItemId, true);
        this.fetchTransformers(this.selectedAccounts);
      } finally {
        this.cascadePrompt = false;
        this.cascadeItemId = null;
        this.cascadeFlows = [];
      }
    },
    fetchAccounts() {
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    }
  }
};